module.exports = __webpack_public_path__ + "static/media/bird-budgie4.9da5c666.aac";